import { blogRootPathname } from '@config'
import { ContentType } from '@entries/content-types'

const mapping: Utils.Object<any, ContentType | string> = {
  [ContentType.ContentfulBlogArticle]: (
    entry: Queries.ContentfulBlogArticleLinkFragment
  ) => `${blogRootPathname}/${entry.slug}`,
  [ContentType.ContentfulBlogTag]: (entry: Queries.ContentfulBlogTagFragment) =>
    `${blogRootPathname}/${entry.slug}`,
  [ContentType.ContentfulStaticPage]: (entry: Queries.ContentfulStaticPage) =>
    `${entry.slug}`,
  [ContentType.ContentfulDeprecatedPage]: (
    entry: Queries.ContentfulDeprecatedPageLinkFragment
  ) => `${entry.pageUrl}`,
}

export const getPath = (entry: Queries.EntryFragment): string => {
  const func = mapping[entry?.__typename]
  if (func) {
    return func(entry)
  }

  return ''
}
